<template id="list-media">
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">
          ประวัติการจัดส่ง
        </li>
      </ol>
    </nav>
    <!-- List cms -->
    <div class="listDeliveryHistory">
      <div class="row">
        <div class="col-md-12">
          <h3>ประวัติการจัดส่ง</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <!-- <general-searchbox
            @searchButtonClick="setCurrentKeywordandSearch"
          ></general-searchbox> -->

          <div class="row">
            <div class="col-4">วันที่จัดส่ง</div>
            <div class="col-3">สถานะ</div>
            <div class="col-3">ข้อความรีวิว</div>
            <div class="col-1"></div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <input
                type="date"
                name="delivery_date"
                class="form-control"
                placeholder="วันที่จัดส่ง"
                v-model="delivery_date_for_search_delivery_history"
              />
            </div>
            <div class="col-md-3">
              <select
                class="form-control"
                v-model="status_for_search_delivery_history"
              >
                <option value="">ทั้งหมด</option>
                <option value="draft">draft</option>
                <option value="published">published</option>
              </select>
            </div>
            <div class="col-md-3">
              <input
                type="text"
                name="review_message"
                class="form-control"
                placeholder="ข้อความรีวิว"
                v-model="tha_review_message_for_search_delivery_history"
              />
            </div>
            <div class="col-md-1">
              <button
                type="button"
                class="btn btn-secondary"
                @click="searchItems"
              >
                ค้นหา
              </button>
            </div>
            <div class="col-md-2">
              <button
                type="button"
                class="btn btn-success float-right"
                data-toggle="modal"
                data-target="#selectImageOfOrderModal"
                ref="decoySelectOrderModalClick"
              >
                เพิ่มประวัติการจัดส่ง
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <div class="row mt-3"  v-if="showLoading">
        <div class="col-md-12">
            <general-loading></general-loading>
        </div>
      </div>
      <general-pagination
        v-if="paginate_data._infos._total && !showLoading"
        :paginate_data="paginate_data"
        @paginateItemClick="setCurrentPageAndSearch"
      ></general-pagination>
      <div class="row mt-3">
        <div class="col-md-12">
          <div
            class="card card-body mt-1"
            v-for="item in items"
            v-bind:key="item.id"
          >
            <div class="row">
              <div class="col-md-2">
                <img
                  :src="item.delivery_image_url"
                  class="img-thumbnail"
                  alt=""
                  style="
                    width: 200px;
                    height: 200px;
                    object-fit: cover;
                    cursor: pointer;
                  "
                />
              </div>
              <div class="col-md-8">
                <div class="row">
                  <div class="col-md-2">คะแนนรีวิว:</div>
                  <div class="col-md-10 text text-secondary">
                    {{ item.rating }}
                    <!--  loop 5 times for show <i class="fa fa-star"></i> -->
                    <i
                      v-for="i in 5"
                      :key="i + '_good_star'"
                      class="fa text ml-1"
                      :class="
                        i <= parseInt(item.rating)
                          ? 'fa-star text-success'
                          : 'fa-star-o text-secondary'
                      "
                    ></i>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2">สถานะ:</div>
                  <div class="col-md-10 text text-secondary">
                    {{ item.status }}
                  </div>
                </div>
                <div class="row"></div>
                <div class="row">
                  <div class="col-md-2">ข้อความรีวิว:</div>
                  <div class="col-md-10 text text-secondary" v-html="convertCR(item.tha_review_message)"></div>
                </div>
                <!-- <div class="row">
                  <div class="col-md-2">รีวิว(Eng):</div>
                  <div class="col-md-10 text text-secondary">
                    {{ item.eng_review_message }}
                  </div>
                </div> -->
              </div>
              <div class="col-md-2">
                <div class="form-group float-right">
                  <a
                    class="btn btn-light"
                    v-bind:href="base_item_url + '/form/' + item.id"
                    >แก้ไข</a
                  >
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-toggle="modal"
                    data-target="#ConfirmDeleteModal"
                    @click="setForDeleteItemId(item.id)"
                  >
                    ลบ
                  </button>
                </div>
              </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-12">
                  <span class="text text-secondary">{{ item.delivery_image_url }} </span>
                </div>
              </div> -->
            <div class="row">
              <div class="col-md-12">
                <span>
                  ออเดอร์#:
                  <span class="text text-secondary"
                    >{{ item.erp_order_id }}
                  </span>
                  ชื่อลูกค้า:
                  <span class="text text-secondary"
                    >{{ item.customer_name }}
                  </span>
                  วันเวลาส่ง:
                  <span class="text text-secondary">{{
                    item.erp_delivery_datetime
                  }}</span>
                  ซ่อน/แสดงชื่อลูกค้า:
                  <span class="text text-secondary">{{
                    item.show_customer_name == 1 ? "แสดง" : "ซ่อน"
                  }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <general-pagination
        v-if="paginate_data._infos._total && !showLoading"
        :paginate_data="paginate_data"
        @paginateItemClick="setCurrentPageAndSearch"
      ></general-pagination>
      <div v-if="recordNotFound" class="alert alert-warning" role="alert">
        ไม่พบข้อมูล
      </div>
    </div>
    <!-- delete modal    -->
    <general-delete-modal
      @ConFirmDeleteClick="performDeleteItem"
    ></general-delete-modal>
    <!-- alert modal    -->
    <button
      style="display: none"
      type="button"
      class="btn btn-primary"
      data-toggle="modal"
      data-target="#AlertModal"
      ref="decoyAlertModalClick"
    >
      test
    </button>
    <general-alert-modal :alertMessage="alertMessage"></general-alert-modal>
    <!-- modal for select order to assign selected images -->
    <div
      class="modal"
      id="selectImageOfOrderModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="selectImageOfOrderModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document" style="max-width: 95%">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row filter-row">
              <div class="col-md-12">
                <!-- input for search order -->
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-3">เลขออเดอร์</div>
                      <div class="col-md-6">ข้อความบป้าย / การ์ด</div>
                      <div class="col-md-3">วันที่จัดส่ง</div>
                    </div>
                    <div class="form-row">
                      <div class="col-md-3">
                        <input
                          type="text"
                          name="order_code"
                          class="form-control"
                          placeholder="เลขออเดอร์"
                          v-model="order_code_for_search"
                          @keyup="delayAndSearchOrders"
                        />
                      </div>
                      <div class="col-md-3">
                        <input
                          type="text"
                          name="first_message_on_card"
                          class="form-control"
                          placeholder="ข้อความบรรทัดที่ 1"
                          v-model="first_message_on_card_for_search"
                          @keyup="delayAndSearchOrders"
                        />
                      </div>
                      <div class="col-md-3">
                        <input
                          type="text"
                          name="second_message_on_card"
                          class="form-control"
                          placeholder="ข้อความบรรทัดที่ 2"
                          v-model="second_message_on_card_for_search"
                          @keyup="delayAndSearchOrders"
                        />
                      </div>
                      <div class="col-md-3">
                        <input
                          type="date"
                          name="delivery_date"
                          class="form-control"
                          placeholder="วันที่จัดส่ง"
                          v-model="delivery_date_for_search_order"
                          @change="searchOrders"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2" v-if="loadingOrder">
              <div class="col-md-6">
                <general-loading></general-loading>
              </div>
              <div class="col-md-6">กำลังค้นหาข้อมูลออเดอร์</div>
            </div>
            <div class="row mt-2" v-if="!loadingOrder && orders.length == 0">
              <div class="col-md-12">
                <div class="alert alert-warning" role="alert">
                  ไม่พบข้อมูลออเดอร์
                </div>
              </div>
            </div>
            <div class="row order-list-modal mt-3" v-if="!loadingOrder">
              <div class="col-md-12">
                <div
                  v-for="order in orders"
                  class="row mt-2"
                  v-bind:key="order.code"
                >
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-body order-card-body">
                        <div class="row">
                          <div class="col-md-5 text">
                            <span class="card-text">
                              {{ order.code }} -
                              <span class="text text-primary">ชื่อลูกค้า: </span
                              >{{ order.customer.name }}
                            </span>
                            <span v-if="order.customer.email != ''">
                              <br />
                              <span class="text text-primary">Email: </span
                              >{{ order.customer.email + "" }}
                            </span>
                            <span v-if="order.customer.line != ''">
                              <br />
                              <span class="text text-primary">Line: </span
                              >{{ order.customer.line }}
                            </span>
                            <p class="card-text">
                              <span class="text text-primary"
                                >ข้อความบรรทัดที่ 1:
                              </span>
                              {{ order.order_items[0].msg_fr }}
                              <br />
                              <span class="text text-primary"
                                >ข้อความบรรทัดที่ 2:
                              </span>
                              {{ order.order_items[0].msg_se }}
                              <br />
                              <span class="text text-primary"
                                >ข้อเน้นย้ำ:
                              </span>
                              {{ order.remark ? order.remark : "" }}
                            </p>
                          </div>
                          <div class="col-md-5">
                            <!-- <div class="row">
                              <div class="col-md-12">รูปจัดส่ง</div>
                            </div> -->
                            <div class="row">
                              <div class="col-md-2">รูปจัดส่ง</div>
                              <div
                                class="col-md-10"
                                v-if="order.delivery[0].photo_after.length > 0"
                              >
                                <a
                                  v-for="photo in order.delivery[0].photo_after"
                                  :key="photo.url"
                                  :href="
                                    base_item_url +
                                    '/form/?delivery_image_url=' +
                                    photo.url +
                                    '&erp_order_id=' +
                                    order.id +
                                    '&customer_name=' +
                                    order.customer.name +
                                    '&actual_delivery_date=' +
                                    order.delivery[0].actual_delivery_date +
                                    '&actual_delivery_time=' +
                                    order.delivery[0].actual_delivery_time
                                  "
                                >
                                  <img
                                    :src="photo.url"
                                    class="img-thumbnail"
                                    alt=""
                                    style="
                                      width: 120px;
                                      height: 120px;
                                      object-fit: cover;
                                    "
                                  />
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-2">
                            <span
                              :class="
                                order.is_assigned_to_delivery_history == 1
                                  ? 'text-success'
                                  : 'text-secondary'
                              "
                            >
                              {{
                                order.is_assigned_to_delivery_history == 1
                                  ? "เอาไปใช้แล้ว"
                                  : "ยังไม่ได้เอาไปใช้"
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <general-pagination
              v-if="orders.length > 0"
              :paginate_data="paginate_order_data"
              @paginateItemClick="setCurrentPageAndSearchOrders"
            ></general-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  props: {
    media_base_url: "",
  },
  data() {
    return {
      orders: [],
      items: [],
      item: {},
      item_id: "",
      paginate_data: {
        _infos: {},
        _base_item_list_url: "",
      },
      paginate_order_data: {
        _infos: {},
        _base_item_list_url: "",
      },
      alertMessage: {
        titleClassName: "warning",
        titleMessage: "แจ้งเตือน!!",
        bodyClassName: "warning",
        bodyMessage: "This is alert",
      },
      edit: false,
      recordNotFound: false,
      showLoading: true,
      formUrl: "/delivery-history/form",
      base_item_url: "/delivery-history",
      currentSearchKeyword: "",
      currentPage: 1,
      currentPerpage: 23,

      delivery_date_for_search_delivery_history: "",
      status_for_search_delivery_history: "",
      tha_review_message_for_search_delivery_history: "",

      loadingOrder: false,
      order_code_for_search: "",
      first_message_on_card_for_search: "",
      second_message_on_card_for_search: "",
      delivery_date_for_search_order: "",
      order_status_for_search: "",
      currentOrderPage: 1,
      currentOrderPerpage: 5,
    };
  },
  mounted() {
    //console.log('Component mounted.')
  },
  created() {
    // this.fetchCmses();
    this.searchItems();
    // this.paginate_data._base_item_list_url = this.base_item_list_url;
    this.delivery_date_for_search_order = new Date().toISOString().slice(0, 10);
    // this.delivery_date_for_search_delivery_history = new Date()
    //   .toISOString()
    //   .slice(0, 10);
    this.searchOrders();
  },
  methods: {
    convertCR(text) {
      return text.split('\r').join('<br>');
    },
    setCurrentKeywordandSearch(searchKeyword) {
      this.currentPage = 1;
      this.currentSearchKeyword = searchKeyword;
      this.searchItems();
    },
    setCurrentPageAndSearch(page) {
      this.currentPage = page;
      this.searchItems();
    },
    searchItems() {
      let url = this.base_item_url + "/list";
      url = url + "?page=" + this.currentPage;
      url = url + "&perpage=" + this.currentPerpage;
      url = url + "&title=" + this.currentSearchKeyword;
      url =
        url +
        "&delivery_date=" +
        this.delivery_date_for_search_delivery_history;
      url = url + "&status=" + this.status_for_search_delivery_history;
      url =
        url +
        "&tha_review_message=" +
        this.tha_review_message_for_search_delivery_history;
      this.fetchItems(url);
    },
    fetchItems(url) {
      this.showLoading = true;
      this.items = [];
      url = url || this.base_item_url + "/list";
      axios
        .get(url)
        .then((response) => {
          this.items = response.data.items;
          this.paginate_data._infos = response.data._infos._paginate;
          this.paginate_data._infos._url_range = this.computePaginate(
            this.paginate_data._infos._last_page
          );
          this.recordNotFound = this.items.length == 0 ? true : false;
          this.showLoading = false;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    computePaginate(lastpage) {
      let result = [];
      let i = 0;
      let data = Object.entries(this.paginate_data._infos._url_range);
      // console.log(this.paginate_data._infos._last_page);
      data.forEach(function (item) {
        if (item[0] > 0 && item[0] <= lastpage) {
          result[i] = item;
          i++;
        }
      });
      // console.log(result);
      return result;
    },
    setForDeleteItemId(item_id) {
      // console.log(item_id);
      this.item_id_for_delete = item_id;
    },
    performDeleteItem() {
      // console.log(this.item_id_for_delete);
      axios
        .post(this.base_item_url + "/" + this.item_id_for_delete + "/delete")
        .then((response) => {
          // console.log(response.data._infos)
          this.searchItems();
        })
        .catch((errors) => {
          if (errors.response.data._infos.result) {
            this.alertMessage.bodyMessage = errors.response.data._infos.result;
            this.$refs.decoyAlertModalClick.click();
          } else {
            console.log(errors.response.data._infos.result);
            alert("ไม่สามารถลบได้ " + errors.response.data);
          }
        });
    },
    delayAndSearchOrders() {
      this.currentOrderPage = 1;
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.searchOrders();
      }, 1000);
    },
    resetOrderCurrentPageAndSearch() {
      this.currentOrderPage = 1;
      this.searchOrders();
    },
    searchOrders() {
      let url = this.base_item_url + "/order/";
      url = url + "?page=" + this.currentOrderPage;
      url = url + "&perpage=" + this.currentOrderPerpage;
      //   url = url + "&store_id=" + this.store_id;
      //   url = url + "&supplier_id=" + this.supplier_id;
      url =
        url + "&actual_delivery_date=" + this.delivery_date_for_search_order;
      url = url + "&order_code=" + this.order_code_for_search;
      url =
        url + "&first_message_on_card=" + this.first_message_on_card_for_search;
      url =
        url +
        "&second_message_on_card=" +
        this.second_message_on_card_for_search;
      url = url + "&status_delivery=" + this.order_status_for_search;
      url =
        url +
        "&only_drafted=" +
        (this.only_drafted_order_for_search ? "y" : "n");

      this.loadingOrder = true;

      axios
        .get(url)
        .then((response) => {
          this.orders = response.data.orders;
          this.paginate_order_data._infos = response.data._infos._paginate;
          this.paginate_order_data._infos._url_range =
            this.computeOrderPaginate(
              this.paginate_order_data._infos._last_page
            );
        })
        .catch((errors) => {
          console.log(errors);
        })
        .finally(() => {
          this.loadingOrder = false;
        });
    },
    setCurrentPageAndSearchOrders(page) {
      this.currentOrderPage = page;
      this.searchOrders();
    },
    computeOrderPaginate(lastpage) {
      let result = [];
      let i = 0;
      let data = Object.entries(this.paginate_order_data._infos._url_range);
      // console.log(this.paginate_data._infos._last_page);
      data.forEach(function (item) {
        if (item[0] > 0 && item[0] <= lastpage) {
          result[i] = item;
          i++;
        }
      });
      // console.log(result);
      return result;
    },
    resetSearchFilter() {
      this.order_code_for_search = "";
      this.first_message_on_card_for_search = "";
      this.second_message_on_card_for_search = "";
      this.order_status_for_search = "";
      this.only_drafted_order_for_search = false;
      this.searchOrders();
    },
  },
};
</script>